import {useReportUserVisibleError} from '@github-ui/copilot-browser-latency/use-report-user-visible-error'
import type {UserErrorCode} from '@github-ui/copilot-browser-latency/user-visible-errors'
import {Banner} from '@primer/react'

import styles from './AttachmentErrorBanner.module.css'

export interface AttachmentErrorBannerProps {
  messages: readonly string[]
  errorCode: UserErrorCode
  onDismiss: () => void
  variant?: 'critical' | 'warning'
  title?: string
  layout?: 'default' | 'compact'
  ref?: React.Ref<HTMLElement>
}

export function AttachmentErrorBanner({
  messages,
  errorCode,
  onDismiss,
  variant = 'critical',
  title = 'Attachment error',
  layout = 'default',
  ref,
}: AttachmentErrorBannerProps) {
  const uniqueMessages = Array.from(new Set(messages))
  // The messages only tell distinct rejections apart locally; they are never reported.
  useReportUserVisibleError(uniqueMessages.length > 0 ? errorCode : undefined, {
    identity: uniqueMessages.join('\n'),
  })
  if (uniqueMessages.length === 0) return null

  const description = (
    <div className={styles.Description}>
      {uniqueMessages.length === 1 ? (
        uniqueMessages[0]
      ) : (
        <ul className={styles.MessageList}>
          {uniqueMessages.map(message => (
            <li key={message}>{message}</li>
          ))}
        </ul>
      )}
    </div>
  )

  return (
    <Banner
      ref={ref}
      description={description}
      hideTitle
      layout={layout}
      onDismiss={onDismiss}
      title={title}
      variant={variant}
    />
  )
}

AttachmentErrorBanner.displayName = 'AttachmentErrorBanner'
